import { render, staticRenderFns } from "./textCardDiscount.vue?vue&type=template&id=32a41876&scoped=true"
import script from "./textCardDiscount.vue?vue&type=script&lang=js"
export * from "./textCardDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a41876",
  null
  
)

export default component.exports